import React, { useEffect, useState } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import axios from 'axios';
import { BASEURL } from "../Config";
import swal from 'sweetalert';
import MyDropzone from "../components/MyDropzone";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";

const EditBook = (props) => {
  const { bid } = useParams();
  const [name, setName] = useState("");
  const [classno, setClassno] = useState(0);
  const [subject, setSubject] = useState("");
  const [nameError, setNameError] = useState(false);
  const [classError, setClassError] = useState(false);
  const [subjectError, setSubjectError] = useState(false);
  const [thumbnail, setThumbnail] = useState("");
  const [thumbnailError, setThumbnailError] = useState(false);
  const [subjects, setSubjects] = useState([]);

  useEffect(() => {
    axios
      .get(`${BASEURL}/api/v1/subjects/fetchall`)
      .then(res => {
        let subjects = [];
        for (let i = 0; i < res.data.length; i++) {
          subjects.push(res.data[i].subject);
        }
        setSubjects(subjects);
      });
    axios.get(`${BASEURL}/api/v1/books/fetch/${bid}`)
      .then(res => {
        setName(res.data.name);
        setClassno(res.data.classno);
        setSubject(res.data.subject);
        setThumbnail(res.data.thumbnail);
      })
      .catch(err => {
        console.log("Fetch Book by bid error", err)
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "name") {
      setName(value);
    } else if (name === "classno") {
      setClassno(value);
    } else if (name === "subject") {
      setSubject(value);
    }
  }

  const validateData = () => {
    let error = false;
    if (name === "" || name === undefined) {
      setNameError(true);
      error = true;
    }
    if (classno === 0 || classno === undefined) {
      setClassError(true);
      error = true;
    }
    if (subject === "" || subject === undefined) {
      setSubjectError(true);
      error = true;
    }
    return error;
  }

  const handleUpdate = () => {
    let validationError = validateData();
    if (validationError) {
      swal('Error in Updating Book', 'Fill the required fields', 'error');
    } else {
      const updateObj = {
        id: props.match.params.bid,
        name: name,
        classno: classno,
        subject: subject,
        thumbnail: thumbnail
      };
      axios.put(`${BASEURL}/api/v1/books/update`, updateObj)
        .then(res => {
          if (res.status === 200) {
            console.log('res.data', res.data);
            swal("Success", "Book Updated successfully", "success")
                .then(function () {
                    window.location = "books";
                })
          } else {
            console.log('res', res)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
          swal('Error in Updating Book', err.response.data, 'error');
          console.log('Update Book Error', err);
        })
    }
  }

  return (
    <div id="wrapper">
      <Sidebar act="books" />
      {/* Content Wrapper */}
      <div className="content-page">
        {/* Main Content */}
        <div className="content">
          <Topbar act="Edit Book" breadcrumbItems={['Test Generator', { label: 'Books', path: '/books' }, 'Edit Book']} />
          {/* container */}
          {/* content */}
          <div className="container-fluid main-container">
            <div className="card main-card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4 col-sm-12">
                    <div className="mb-3">
                      <label htmlFor="bookname" className="form-label">Book Name *</label>
                      <input type="text" id="bookname" className="form-control" onChange={handleChange}
                        name="name" placeholder="Enter Book Name"
                        value={name} />
                      {nameError ? <p className="errTxt">Book Name is Required</p> : ''}
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="form-group mb-3">
                      <label htmlFor="classNo" className="form-label">Class *</label>
                      <select className="form-select"
                        onChange={handleChange}
                        name="classno" value={classno}>
                        <option value="0">Select class</option>
                        <option value="Nursery">Nursery</option>
                        <option value="LKG">LKG</option>
                        <option value="UKG"> UKG</option>
                        <option value="1">Class 1</option>
                        <option value="2">Class 2</option>
                        <option value="3">Class 3</option>
                        <option value="4">Class 4</option>
                        <option value="5">Class 5</option>
                        <option value="6">Class 6</option>
                        <option value="7">Class 7</option>
                        <option value="8">Class 8</option>
                        <option value="9">Class 9</option>
                        <option value="10">Class 10</option>
                        <option value="11">Class 11</option>
                        <option value="12">Class 12</option>
                      </select>
                      {classError ? <p className="errTxt">Class is Required</p> : ''}
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="mb-3">
                      <label htmlFor="subject" className="form-label">Subject</label>
                      <select className="form-select"
                        onChange={handleChange}
                        name="subject" value={subject}>
                        <option value="0">Select Subject</option>
                        {subjects.map((subjectName, idx) =>
                          <option value={subjectName} key={idx}>{subjectName}</option>
                        )}
                      </select>
                      {subjectError ? <p className="errTxt">Subject is Required</p> : ''}
                    </div>
                  </div>
                  <div className="col-md-12 col-sm-12">
                    <div className="mb-3">
                      <label>Upload Thumbnail</label>
                      <MyDropzone file={thumbnail} setFile={setThumbnail} setError={setThumbnailError} fromPage="editBookPage" />
                      {thumbnailError ? <p className="errTxt">Thumbnail is Required</p> : ''}
                    </div>
                  </div>
                </div>
                
                <div className="mb-2 d-flex">
                  <button type="submit" className="btn btn-customprimary" onClick={handleUpdate}>Update</button>
                </div>
                {/* end row */}
              </div> {/* end card-body */}
            </div> {/* end card*/}
          </div>
          {/* End of Main Content */}
          <Footer />
        </div>
        {/* End of Content Wrapper */}
      </div>
    </div>
  );
}

export default EditBook;
